import { mutation } from '../../../../1_shared/api/apiInstance';

import { IFeedbackPost } from './interfaces/IFeedbackPost';

export const addFeedback = mutation<IFeedbackPost, null>();
